module.exports = __webpack_public_path__ + "img/roi.4acb7269.png";